import { createAction, props } from '@ngrx/store';
import {NodeItem} from '../../../projektverwaltung/node.model';

export const loadProjektauswahlNodesStart = createAction('AUSWERTUNGEN::LOAD_PROJEKTAUSWAHLNODES_START');
export const loadProjektauswahlNodesSucceeded = createAction(
    'AUSWERTUNGEN::LOAD_PROJEKTAUSWAHLNODES_SUCCEEDED',
    props<{ item: NodeItem[] }>(),
);
export const loadProjektauswahlNodesFailed = createAction('AUSWERTUNGEN::LOAD_PROJEKTAUSWAHLNODES_FAILED', props<{ error: Error }>());
